// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "flowbite"
import Swal from "sweetalert2"

const THEME_STORAGE_KEY = "potm-theme"
const DEFAULT_THEME = "ocean"

function applyTheme(themeName) {
  const theme = themeName || DEFAULT_THEME
  document.documentElement.dataset.theme = theme

  document.querySelectorAll("[data-theme-choice]").forEach((button) => {
    const selected = button.dataset.themeChoice === theme
    button.setAttribute("aria-pressed", selected ? "true" : "false")
    button.classList.toggle("ring-2", selected)
    button.classList.toggle("ring-white", selected)
    button.classList.toggle("ring-offset-2", selected)
    button.classList.toggle("ring-offset-stone-950", selected)
  })

  const label = document.querySelector("[data-theme-current]")
  if (label) label.textContent = theme
}

function setupThemeSwitcher() {
  const savedTheme = window.localStorage.getItem(THEME_STORAGE_KEY) || document.documentElement.dataset.theme || DEFAULT_THEME
  applyTheme(savedTheme)

  document.querySelectorAll("[data-theme-choice]").forEach((button) => {
    if (button.dataset.themeBound === "true") return
    button.dataset.themeBound = "true"

    button.addEventListener("click", () => {
      const theme = button.dataset.themeChoice
      window.localStorage.setItem(THEME_STORAGE_KEY, theme)
      applyTheme(theme)
    })
  })
}

function upgradeSweetAlertConfirms() {
  document.querySelectorAll("[data-turbo-confirm]").forEach((element) => {
    if (element.dataset.sweetalertConfirmBound === "true") return

    element.dataset.sweetalertConfirm = element.dataset.turboConfirm
    delete element.dataset.turboConfirm
  })
}

function bindSweetAlertConfirm(element) {
  if (element.dataset.sweetalertConfirmBound === "true") return

  element.dataset.sweetalertConfirmBound = "true"

  if (element.tagName === "FORM") {
    element.addEventListener("submit", async (event) => {
      if (element.dataset.sweetalertConfirmed === "true") {
        delete element.dataset.sweetalertConfirmed
        return
      }

      const message = element.dataset.sweetalertConfirm
      if (!message) return

      event.preventDefault()

      const result = await Swal.fire(sweetAlertOptionsFor(element, message))

      if (!result.isConfirmed) return

      element.dataset.sweetalertConfirmed = "true"
      element.requestSubmit(event.submitter)
    })

    return
  }

  element.addEventListener("click", async (event) => {
    if (element.dataset.sweetalertConfirmed === "true") {
      delete element.dataset.sweetalertConfirmed
      return
    }

    const message = element.dataset.sweetalertConfirm
    if (!message) return

    event.preventDefault()

    const result = await Swal.fire(sweetAlertOptionsFor(element, message))

    if (!result.isConfirmed) return

    element.dataset.sweetalertConfirmed = "true"
    element.click()
  })
}

function sweetAlertOptionsFor(element, message) {
  const expectedValue = element.dataset.sweetalertInputMatch
  const inputLabel = element.dataset.sweetalertInputLabel

  const options = {
    title: "Are you sure?",
    text: message,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Confirm",
    cancelButtonText: "Cancel",
    reverseButtons: true
  }

  if (!expectedValue) return options

  return {
    ...options,
    input: "text",
    inputLabel: inputLabel || `Type "${expectedValue}" to confirm.`,
    inputPlaceholder: expectedValue,
    focusConfirm: false,
    preConfirm: (value) => {
      if (value?.trim() === expectedValue) return value

      Swal.showValidationMessage(`Please type "${expectedValue}" exactly.`)
    }
  }
}

function setupSweetAlertConfirms() {
  upgradeSweetAlertConfirms()

  document.querySelectorAll("[data-sweetalert-confirm]").forEach((element) => {
    bindSweetAlertConfirm(element)
  })
}

document.addEventListener("turbo:load", setupThemeSwitcher)
document.addEventListener("turbo:load", setupSweetAlertConfirms)
